import { __awaiter, __extends, __generator } from "tslib";
export var HTTP_METHODS;
(function (HTTP_METHODS) {
    HTTP_METHODS["GET"] = "GET";
    HTTP_METHODS["DELETE"] = "DELETE";
    HTTP_METHODS["PUT"] = "PUT";
    HTTP_METHODS["POST"] = "POST";
    HTTP_METHODS["PATCH"] = "PATCH";
})(HTTP_METHODS || (HTTP_METHODS = {}));
var GenericAPI = /** @class */ (function () {
    function GenericAPI(baseUrl, getHeadersCb) {
        if (baseUrl === void 0) { baseUrl = ''; }
        if (getHeadersCb === void 0) { getHeadersCb = function () { return ({}); }; }
        this.baseUrl = baseUrl;
        this.getHeadersCb = getHeadersCb;
        this.credentials = 'same-origin';
    }
    GenericAPI.prototype.get = function (path) {
        return this.callApi(path, undefined, HTTP_METHODS.GET);
    };
    GenericAPI.prototype.delete = function (path, body) {
        return this.callApi(path, body, HTTP_METHODS.DELETE);
    };
    GenericAPI.prototype.put = function (path, body) {
        return this.callApi(path, body, HTTP_METHODS.PUT);
    };
    GenericAPI.prototype.post = function (path, body) {
        return this.callApi(path, body, HTTP_METHODS.POST);
    };
    GenericAPI.prototype.patch = function (path, body) {
        return this.callApi(path, body, HTTP_METHODS.PATCH);
    };
    GenericAPI.prototype.callApi = function (path, body, method) {
        var _this = this;
        if (method === void 0) { method = HTTP_METHODS.GET; }
        return new Promise(function (resolve, reject) {
            fetch("" + _this.baseUrl + path, {
                method: method,
                headers: _this.getHeadersCb(),
                body: Object.is(body, undefined) ? null : JSON.stringify(body),
                credentials: _this.credentials,
            })
                .then(function (response) { return __awaiter(_this, void 0, void 0, function () {
                var result;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, response.text()];
                        case 1:
                            result = _a.sent();
                            try {
                                result = JSON.parse(result);
                            }
                            catch (e) {
                                // not needed
                            }
                            if (!response.ok) {
                                reject(new GenericApiError(response.status, result, path, this.baseUrl, method));
                            }
                            resolve(result);
                            return [2 /*return*/];
                    }
                });
            }); })
                .catch(function (e) {
                throw e;
            });
        });
    };
    return GenericAPI;
}());
export { GenericAPI };
var GenericApiError = /** @class */ (function (_super) {
    __extends(GenericApiError, _super);
    function GenericApiError(status, payload, path, baseUrl, method) {
        var _this = _super.call(this, getError(status, path, baseUrl, method)) || this;
        _this.status = status;
        _this.payload = payload;
        return _this;
    }
    return GenericApiError;
}(Error));
export { GenericApiError };
var getError = function (status, path, baseUrl, method) {
    switch (status) {
        case 404:
            return "404 Not found " + method + " " + baseUrl + path;
        default:
            return "Request failed";
    }
};
//# sourceMappingURL=generic.js.map